// Stile mappa "Fuma World" — mondo di gioco notturno neon.
// Base: stile vettoriale CARTO "dark-matter" (no API key, CDN Fastly globale,
// molto affidabile e con CORS aperto: strade, edifici, acqua, parchi, etichette).
// Al caricamento ridipingiamo i layer con la palette neon (vedi neonizeCartoStyle).
export const CARTO_STYLE_URL = "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json";

const NAVY = "#0b0e28";
const WATER = "#0c2f4d";
const GREEN = "#123a22";
const BUILDING = "#2b2455";
const ROAD_MAJOR = "#9aa2e6";
const ROAD = "#454d8c";

// Ridipinge lo stile base CARTO con la palette "Fuma World" in modo difensivo:
// itera i layer esistenti e ne modifica solo il paint, senza assumere nomi specifici.
export function neonizeCartoStyle(map) {
  let layers = [];
  try { layers = map.getStyle().layers || []; } catch (e) { return; }
  for (const l of layers) {
    const id = l.id || "";
    const set = (prop, val) => { try { map.setPaintProperty(id, prop, val); } catch (e) {} };
    try {
      if (l.type === "background") {
        set("background-color", NAVY);
      } else if (l.type === "fill") {
        if (/water/i.test(id)) set("fill-color", WATER);
        else if (/(park|wood|grass|green|forest|landcover|pitch|golf|cemetery)/i.test(id)) { set("fill-color", GREEN); set("fill-opacity", 0.6); }
        else if (/building/i.test(id)) { set("fill-color", BUILDING); set("fill-opacity", 0.85); }
        else set("fill-color", NAVY);
      } else if (l.type === "line") {
        if (/(water|river|stream|canal)/i.test(id)) set("line-color", WATER);
        else if (/(road|street|transp|bridge|tunnel|motorway|highway|path|rail|link)/i.test(id)) {
          const major = /(motorway|trunk|primary|main|highway)/i.test(id);
          set("line-color", major ? ROAD_MAJOR : ROAD);
          set("line-opacity", 0.95);
        } else {
          set("line-color", "#2a2f55");
        }
      } else if (l.type === "fill-extrusion") {
        set("fill-extrusion-color", "#4c3f92");
        set("fill-extrusion-opacity", 0.9);
      } else if (l.type === "symbol") {
        // Nomi geografici ORIGINALI MapLibre: puliti e leggibili, nessuna modifica al testo.
        set("text-color", "#c3c8f2");
        set("text-halo-color", NAVY);
        set("text-halo-width", 1.4);
      }
    } catch (e) { /* layer non modificabile: ignora */ }
  }
  addBuildings3D(map);
}

// Edifici 3D estrusi (effetto "città di gioco") dai tile CARTO (source-layer "building",
// con render_height/render_min_height). Crescono da zoom 14 a 16 e restano sotto le etichette.
function addBuildings3D(map) {
  try {
    if (map.getLayer("fuma-buildings-3d")) return;
    let firstSymbol;
    for (const l of (map.getStyle().layers || [])) {
      if (l.type === "symbol") { firstSymbol = l.id; break; }
    }
    map.addLayer({
      id: "fuma-buildings-3d",
      type: "fill-extrusion",
      source: "carto",
      "source-layer": "building",
      minzoom: 13.5,
      filter: ["!=", ["get", "hide_3d"], true],
      paint: {
        "fill-extrusion-color": [
          "interpolate", ["linear"], ["get", "render_height"],
          0, "#2f2769", 25, "#5140c9", 70, "#7a63ff",
        ],
        "fill-extrusion-height": [
          "interpolate", ["linear"], ["zoom"],
          13.5, 0, 16, ["coalesce", ["get", "render_height"], 8],
        ],
        "fill-extrusion-base": [
          "interpolate", ["linear"], ["zoom"],
          13.5, 0, 16, ["coalesce", ["get", "render_min_height"], 0],
        ],
        "fill-extrusion-opacity": 0.82,
      },
    }, firstSymbol);
  } catch (e) { /* source non pronta: ignora */ }
}
